<template>
  <div>
    <h1>Warehouse Behavior</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Outgoing Pattern By Day</h5>
      <by-day
        :filterUrl="filterUrl"
        :type="'outgoing'"
      ></by-day>
    </div>
    <!-- Registered By Category End -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Outgoing Pattern By Hour</h5>
      <by-hour
        :filterUrl="filterUrl"
        :type="'outgoing'"
      ></by-hour>
    </div>
    <!-- Registered By Category End -->

    <!-- Registered By Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Outgoing Pattern By Date</h5>
      <by-date
        :filterUrl="filterUrl"
        :type="'outgoing'"
      ></by-date>
    </div>
    <!-- Registered By Category End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import ByDay from './children/incomingPatternByDay'
  import ByHour from './children/incomingPatternByHour'
  import ByDate from './children/incomingPatternByDate'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      ByDay,
      ByHour,
      ByDate,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>